import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// App provides its own HelmetProvider, so it is self-contained.
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap prerenders static HTML into #root; hydrate it instead of
// re-rendering from scratch so the markup crawlers receive stays intact.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
